import { cn, Link } from '@divlab/divanui';

import * as ModalWindows from '@Stores/ModalWindows';
import { useRequest } from '@Contexts/Request';
import useTranslation from '@Queries/useTranslation';
import styles from './Footnotes.module.css';

import type { FC, HTMLAttributes } from 'react';

interface FootnotesProps extends HTMLAttributes<HTMLDivElement> {
  footnotes: FootnotesData;
}

export type FootnotesData = string[];

const Footnotes: FC<FootnotesProps> = (props) => {
  const { className, footnotes, ...restProps } = props;
  const { t } = useTranslation();
  const { country } = useRequest();
  const detailed = t('detailed');
  const rules = t('rules');

  const handleClickRules = () => {
    const hash = country === 'KAZ' ? '#mebel-club-rules' : '#divan-club-rules';

    ModalWindows.open('StaticInfo', { slug: 'divan-club-rules', hash });
  };

  return (
    <div className={cn(styles.wrapper, className)} {...restProps}>
      {footnotes.map((footnote, index) => (
        <div key={footnote} className={styles.footnote}>
          {footnote}
          {index === 1 && (
            <>
              {' '}
              {detailed}{' '}
              <Link view='native' onClick={handleClickRules}>
                {rules}
              </Link>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default Footnotes;
